<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <div class="item-wp">
          <div class="item-son" v-if="addShow">
            <el-button size="mini" type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
          </div>
          <div v-if="searchShow">
            <el-input v-model="search.searchKey" placeholder="请输入类型名称"
                      style="width: 200px;margin-right: 10px;height: 28px"></el-input>
            <el-select v-model="search.status" placeholder="请选择">
              <el-option label="已发布" value="1">
              </el-option>
              <el-option label="未发布" value="0">
              </el-option>
            </el-select>
            <el-button @click="queryStyleData" type="primary" style="margin-left: 10px">搜索</el-button>
          </div>
        </div>
      </div>
    </div>
    <div style="overflow: hidden">
      <div class="list-style" v-for="(item,index) in tableData" :key="index">
        <el-image
            style="width: 250px; height: 160px"
            :src="item.logo2"
            fit="contain"
        ></el-image>
        <div class="cover-conter">
          <div class="flex-box flex-center-items" style="margin-bottom: 10px">
            <div>{{ item.name }}</div>
          </div>
          <div style="margin-bottom: 10px">
            <span style="margin-right: 10px">是否开启测算</span>
            <el-switch
                :disabled="statusShow"
                :value="item.status"
                :active-value="1"
                :inactive-value="0"
                @change="changeSwitch(item)"
            >
            </el-switch>
          </div>
          <div>
            <span style="margin-right: 10px">是否列表显示</span>
            <el-switch
                :disabled="listShow"
                :value="item.shows"
                :active-value="1"
                :inactive-value="0"
                @change="changeShowSwitch(item)"
            >
            </el-switch>
          </div>
          <div class="style-elemx" style="width:100%; white-space: nowrap; text-overflow:ellipsis; overflow:hidden; ">
            {{ item.subject }}
          </div>
          <div class="time ">
            <div style="width: 100%; margin-top:20px">
              <el-button
                  size="mini"
                  @click="handleClick('edit', item)"
                  type="success"
                  plain
                  v-if="editShow"
              >编辑
              </el-button
              >
              <el-button
                  v-if="deleteShow"
                  size="mini"
                  @click="handleDelete(item)"
                  type="danger"
                  plain
              >删除
              </el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑塔罗类型"
        :visible.sync="dialogVisible"
        width="660px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item label="分类" prop="tarotCategoryId">
            <el-select
                v-model="params.tarotCategoryId"
                clearable
                filterable
                :disabled="this.submitType =='edit'"
                placeholder="状态"
            >
              <el-option
                  v-for="item in tarotCategoryList"
                  :key="item.tarotCategoryId"
                  :label="item.name"
                  :value="item.tarotCategoryId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-row type="flex" style="justify-content: space-between">
            <el-col :span="12">
              <el-form-item label="类型名称" prop="name">
                <el-input
                    placeholder="请填写类型名称"
                    v-model="params.name"
                    style="width: 234px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="类型标识" prop="code">
                <el-input
                    placeholder="请填写类型标识"
                    v-model="params.code"
                    style="width:164px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="类型简介" prop="subject">
            <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 4 }"
                placeholder="请填写类型简介"
                v-model="params.subject"
            >
            </el-input>
          </el-form-item>
          <el-row type="flex" style="justify-content: space-between">
            <el-col :span="8">
              <el-form-item label="封面图" prop="logo">
                <div class="diplay" style="margin-right: 10px">
                  <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in coverImgList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy('cover')"
                  />
                </span>
                    <div
                        class="up-btn"
                        style="width: 75px; height: 75px; line-height: 80px"
                        @click="getPolicy('cover')"
                        v-if="isCoverMoer"
                    >
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                  <input
                      type="file"
                      ref="cover"
                      @change="getFile('cover')"
                      accept="image/png,image/jpg"
                  />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="按钮图" prop="btnImg">
                <div class="diplay" style="margin-right: 10px">
                  <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in ButtonImgList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy('button')"
                  />
                </span>
                    <div
                        class="up-btn"
                        style="width: 75px; height: 75px; line-height: 80px"
                        @click="getPolicy('button')"
                        v-if="isButtonMoer"
                    >
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                  <input
                      type="file"
                      ref="button"
                      @change="getFile('button')"
                      accept="image/png,image/jpg"
                  />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="落地头图" prop="logo2">
                <div class="diplay" style="margin-right: 10px">
                  <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in LandingheadImgList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy('head')"
                  />
                </span>
                    <div
                        class="up-btn"
                        style="width: 75px; height: 75px; line-height: 80px"
                        @click="getPolicy('head')"
                        v-if="isHeadMoer">
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                  <input
                      type="file"
                      ref="head"
                      @change="getFile('head')"
                      accept="image/png,image/jpg"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="10">
              <el-form-item label="好评率" prop="favorable">
                <el-input
                    placeholder="请填写好评率"
                    v-model="params.favorable"
                    style="width:60px;margin-right: 5px"
                ></el-input>
                %
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="抽牌引导" prop="guideDescr">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 4 }"
                    placeholder="抽牌引导"
                    v-model="params.guideDescr"
                    style="width: 280px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="有偿说明" prop="feeDescr">
            <el-input
                placeholder="请填写有偿说明"
                v-model="params.feeDescr"
            >
            </el-input>
          </el-form-item>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="支付价" prop="payPrice">
                <el-input
                    placeholder="请填写支付价"
                    v-model="params.payPrice"
                    style="width: 160px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="原价" prop="rawPrice">
                <el-input
                    placeholder="请填写原价"
                    v-model="params.rawPrice"
                    style="width: 160px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="6">
              <el-form-item label="测算人数">
                <el-input
                    placeholder="请填写测算人数"
                    v-model="params.buys"
                    type="number"
                    style="width: 60px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="VIP免费">
                <el-switch
                    v-model="params.vipFree"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="免费测算">
                <el-switch
                    v-model="params.free"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="推荐会员">
                <el-switch
                    v-model="params.recomVip"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="支付说明" prop="payIntro">
              <rich-text :keyWord="'payIntro'" :params="params" v-if="flag"></rich-text>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="详情" prop="detail">
              <rich-text :keyWord="'detail'" :params="params" v-if="flag"></rich-text>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {ossUpload} from "@utils/filters/upload";
import richText from "../../../components/richText.vue";
import RichText from "../../../components/richText";

export default {
  name: "typeList",
  components: {RichText},
  comments: {richText},
  data() {
    return {
      tableData: [],
      value: '',
      dialogVisible: false,
      params: {},
      rules: {
        logo: [{required: true, message: "请上传列表图", trigger: "change"}],
        btnImg: [{required: true, message: "请上传按钮图", trigger: "change"}],
        tarotCategoryId: [{required: true, message: "请选择分类", trigger: "change"}],
        logo2: [{required: true, message: "请上传落地头图", trigger: "change"}],
        name: [{required: true, message: "请填写类型名称", trigger: "blur"}],
        code: [{required: true, message: "请填写类型标识", trigger: "blur"}],
        subject: [{required: true, message: "请填写类型简介", trigger: "change"}],
        favorable: [{required: true, message: "请填写好评率", trigger: "blur"}],
        guideDescr: [{required: true, message: "请填写抽牌引导", trigger: "blur"}],
        payPrice: [{required: true, message: "请填写支付价", trigger: "blur"}],
        rawPrice: [{required: true, message: "请填写原价", trigger: "blur"}],
        // feeDescr: [{ required: true, message: "请填写有偿说明", trigger: "blur" }],
        detail: [{required: true, message: "请填写详情", trigger: "blur"}],
      },
      coverImgList: [],
      isCoverMoer: true,
      ButtonImgList: [],
      isButtonMoer: true,
      LandingheadImgList: [],
      isHeadMoer: true,
      flag: false,
      submitType: '',
      search: {},
      tarotCategoryList: [],

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
      listShow: true
    }
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        /* 以下：清空所有图片  */
        this.coverImgList = [];
        this.isCoverMoer = true;
        this.ButtonImgList = [];
        this.isButtonMoer = true;
        this.LandingheadImgList = [];
        this.isHeadMoer = true;
      }
    },
  },
  mounted() {
    this.queryStyleData()
    this.getTarotCategoryList()
    this.getPermissionButtonList()
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'tarot:type:query') {
            this.searchShow = true
          }
          if (item.code == 'tarot:type:add') {
            this.addShow = true
          }
          if (item.code == "tarot:type:delete") {
            this.deleteShow = true
          }
          if (item.code == "tarot:type:edit") {
            this.editShow = true
          }
          if (item.code == "tarot:type:status") {
            this.statusShow = false
          }
          if (item.code == "tarot:type:show") {
            this.listShow = false
          }
        })
      }
    },
    //获取分类列表
    async getTarotCategoryList() {
      this.loading = true;
      const {data: resData} = await this.$get("/tarot/category/list?paging=false");
      this.loading = false;
      if (resData.result != 200) return;
      this.tarotCategoryList = resData.data
    },
    //新增编辑弹框
    async handleClick(e, item) {
      this.submitType = e
      if (e == 'edit') {
        this.loading = true;
        const {data: resData} = await this.$get("tarot/type/" + item.tarotTypeId);
        this.loading = false;
        if (resData.result != 200) return;
        this.params = resData.data
        this.params.favorable = this.params.favorable / 100
        this.params.payPrice = this.params.payPrice / 100
        this.params.rawPrice = this.params.rawPrice / 100
        if (resData.data.logo) {
          this.coverImgList[0] = resData.data.logo
          this.isCoverMoer = false
        }
        if (resData.data.btnImg) {
          this.ButtonImgList[0] = resData.data.btnImg
          this.isButtonMoer = false
        }
        if (resData.data.logo2) {
          this.LandingheadImgList[0] = resData.data.logo2
          this.isHeadMoer = false
        }
        this.dialogVisible = true
      } else {
        this.dialogVisible = true
      }
      this.flag = false;
      this.$nextTick(() => {
        this.flag = true;  //组件生命重新加载
      });
    },
    //新增修改提交
    handleEdit() {
      let numPay = ((this.params.payPrice) * 100).toFixed(2)
      let numRaw = ((this.params.rawPrice) * 100).toFixed(2)
      let favorable = ((this.params.favorable) * 100).toFixed(2)
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.params.payPrice = parseInt(numPay);
          this.params.rawPrice = parseInt(numRaw);
          this.params.favorable = parseInt(favorable);
          if (this.submitType == "add") {
            const {data: resData} = await this.$post(
                "/tarot/type/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.queryStyleData();
            this.dialogVisible = false;
            this.$message.success("添加成功!");
            this.params = {};
          }
          if (this.submitType == "edit") {
            const {data: resData} = await this.$put(
                "/tarot/type/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.queryStyleData();
            this.dialogVisible = false;
            this.$message.success("修改成功!");
          }
        });
      });
    },
    //图片上传
    getPolicy(e) {
      this.$refs[e].dispatchEvent(new MouseEvent("click"));
    },

    async getFile(e) {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs[e].files[0],
          resData.data,
          "one", //'more','one'
      );
      if (e == 'cover') {
        this.isCoverMoer = false;
        this.coverImgList = addRoutes;
        this.params.logo = addRoutes[0];
      } else if (e == 'button') {
        this.isButtonMoer = false;
        this.ButtonImgList = addRoutes;
        this.params.btnImg = addRoutes[0];
      } else if (e == 'head') {
        this.isHeadMoer = false;
        this.LandingheadImgList = addRoutes;
        this.params.logo2 = addRoutes[0];
      }
    },
    //获取分类列表
    async queryStyleData() {
      this.loading = true;
      const {data: resData} = await this.$get("tarot/type/list", {
        params: {
          ...this.search,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if(resData.data){
        this.tableData = resData.data.sort(function (a, b) {
          return b.seq - a.seq;
        });
      }else {
        this.tableData = []
      }

    },
    //修改上下架状态
    async changeSwitch(e) {
      const {data: resData} = await this.$put(
          `tarot/type/status/${e.tarotTypeId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (e.status) {
        e.status = 0
      } else {
        e.status = 1
      }
      this.$message({
        message: resData.message,
        type: "success",
      });
    },
    //修改列表显示状态
    async changeShowSwitch(e) {
      const {data: resData} = await this.$put(
          `tarot/type/shows/${e.tarotTypeId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (e.shows) {
        e.shows = 0
      } else {
        e.shows = 1
      }
      this.$message({
        message: resData.message,
        type: "success",
      });
    },
    //删除分类
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `tarot/type/${row.tarotTypeId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.queryStyleData();
        this.$message.success("删除成功!");
      });
    },
  }
}
</script>

<style scoped lang="scss">
.list-style {
  background: #fff;
  width: 250px;
  padding-bottom: 10px;
  margin: 0 20px 20px 0;
  float: left;
}

.cover-conter {
  margin: 10px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.flex-center-items {
  justify-content: space-between;
  align-items: center;
}

.style-elemx {
  font-size: 14px;
  margin-top: 15px;
}

.time {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}

.item-wp {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>